<template src="./export.html"></template>

<script>
import VueResizable from 'vue-resizable';
import goodsTopMenu from "@/components/goods/components/topMenu";
import Pagination from "@/components/components/pagination";
import RangeFilter from "@/components/components/RangeFilter";
import {createNamespacedHelpers} from 'vuex';
import {config} from "@/config";

const {mapGetters, mapActions} = createNamespacedHelpers('goods/_export');

export default {
  name: "Handler",
  components: {
    VueResizable,
    goodsTopMenu,
    Pagination,
    RangeFilter,
  },
  data() {
    return {
      cellDetailText: '',
      cellDetailLink: '',
      cellDetailLinkList: [],
      windowHeight: false,
      mainTableTop: false,
      mainErrorTableTop: false,
      hostApi: config.apiUrl,
      tabScrollStyle: {
        width: '1920px',
        float: 'none'
      },
      exportListStyle: {
        height: '2000px'
      },
      resizeWidth: '1920px',
      idSign: false,
      idToSign: false,
      options: [
        {value: '=', text: '='},
        {value: '>', text: '>'},
        {value: '<', text: '<'}
      ],
      filterData: {},
      rangeFilterData: {},
      idFilter: null,
      idToFilter: null,
      includeFirstRow: false,
      separatorList: [';', ',', 'tab'],
      selectedSeparator: ';',
      columnList: [],
      affiliateField: {},
      isSaving: null,
      isExporting: null,
      exportName: '',
      confirmationDeleteId: null,
      deletedName: '',
      andExecute: false,
      showOverlay: false
    }
  },
  methods: {
    ...mapActions(['GET_ALL', 'EXPORT_SAVE', 'EXPORT_LIST_UPDATE', 'EXPORT_EXECUTE', 'EXPORT_DELETE']),
    showContentFromCell: function (event) {
      this.cellDetailLink = '';
      this.cellDetailLinkList = [];
      this.cellDetailText = event.target.innerHTML;
    },
    markCell: function (event) {
      // toggle focus of cell
      console.log(event.target);
      const textEl = this.$refs.mainTable.$el;
      const selectedEl = textEl.querySelector('.selectedCall');
      if (selectedEl != null) {
        selectedEl.classList.remove('selectedCall');
      }
      event.target.classList.add('selectedCall');
    },
    markCellSpan: function (ref) {
      // toggle focus of cell
      const textEl = this.$refs.mainTable.$el;
      const selectedEl = textEl.querySelector('.selectedCall');
      if (selectedEl != null) {
        selectedEl.classList.remove('selectedCall');
      }
      this.$refs[ref].classList.add('selectedCall');
    },
    showCellContent: function (text) {
      // show detail
      this.cellDetailLink = '';
      this.cellDetailText = '';
      this.cellDetailLinkList = [];
      if (text.indexOf('http') !== -1) {
        this.cellDetailLink = text;
      } else {
        this.cellDetailText = text;
      }
    },
    showPhotoPdf: function (value) {
      // show detail
      this.cellDetailLink = '';
      this.cellDetailText = '';
      this.cellDetailLinkList = value;
    },
    goToPage: function (page) {
      this.$store.commit('goods/_export/CURRENT_PAGE', page);
      this.GET_ALL({th: this});
    },
    perPage: function (page) {
      this.$store.commit('goods/_export/PAGE_SIZE', page);
      this.GET_ALL({th: this});
    },
    widthTab: function () {
      let leftMargin = 200;
      this.tabScrollStyle.width = (window.innerWidth - leftMargin) + 'px';
      this.resizeWidth = (window.innerWidth - leftMargin) + 'px';
    },
    getCommentTitle: function (data) {
      if (data.field.key.indexOf('additional_') != -1) {
        let number = data.field.key.replace('additional_', '');
        return data.item['comment_' + number] != null ? data.item['comment_' + number] : '';
      }

      return '';
    },
    changeSing: function (sing, val, rangeFilterData) {
      if (val == '' || val == null || val == undefined) {
        return;
      }

      this.setFilter(rangeFilterData);
    },
    changeRangeVal: function (sing, val, rangeFilterData, resetFilter) {
      this.resetRangeFilterFunction = resetFilter
      if (sing == undefined) {
        return;
      }

      this.setFilter(rangeFilterData);
    },
    setFilter: function (rangeFilterData) {
      this.$store.commit('goods/_export/CURRENT_PAGE', 1)
      this.$store.commit('goods/_export/FILTER_DATA', this.filterData)
      if (rangeFilterData !== undefined) {
        this.$store.commit('goods/_export/RANGE_FILTER_DATA', rangeFilterData)
      }
      this.GET_ALL({th: this})
      this.isFiltered = this.rangeFilterIsSelect() || this.simpleFilterIsSelect()
    },
    simpleFilterIsSelect: function () {
      for (let key in this.filterData) {
        if (this.filterData[key] != "") {
          return true
        }
      }

      return false
    },
    rangeFilterIsSelect: function () {
      if (this.RANGE_FILTER_DATA !== undefined) {
        for (let key in this.RANGE_FILTER_DATA.fromVal) {
          if (this.RANGE_FILTER_DATA.fromVal[key] != "" && this.RANGE_FILTER_DATA.fromSign[key] !== undefined) {
            return true
          }
        }

        for (let key in this.RANGE_FILTER_DATA.toVal) {
          if (this.RANGE_FILTER_DATA.toVal[key] != "" && this.RANGE_FILTER_DATA.toSign[key] !== undefined) {
            return true
          }
        }
      }

      return false
    },
    initPageSize: function () {
      let winHeight = window.innerHeight;
      this.exportListStyle.height = (winHeight - 202) + 'px';
      winHeight = Math.round((winHeight - 420) / 24.5);
      this.$store.commit('goods/_export/PAGE_SIZE', winHeight);
    },
    sortingChanged: function (ctx) {
      this.$store.commit('goods/_export/CURRENT_SORT_DIR', ctx.sortDesc ? 'desc' : 'asc');
      this.$store.commit('goods/_export/CURRENT_SORT', ctx.sortBy);
      this.GET_ALL({th: this});
    },
    save: function (execute) {
      if (this.exportName == '') {
        this.$bvModal.show('setExportName');
        if (execute) {
          this.andExecute = true;
        }
      } else {
        this.EXPORT_SAVE({th: this, execute: this.andExecute});
      }
    },
    clearSelected: function (key) {
      this.$delete(this.affiliateField, key);
    },
    exportDelete: function (id, name) {
      if (this.confirmationDeleteId == null) {
        this.confirmationDeleteId = id;
        this.deletedName = name;
        this.$bvModal.show('confirmationDeletion');
        return;
      }
      let ref = 'deleteButton_' + id;
      this.EXPORT_DELETE({
        th: this,
        id: id,
        ref: ref
      });
      this.confirmationDeleteId = null;
    },
    executeExportById: function () {
      console.log(this.$refs['execute_' + this.andExecute][0]);
      this.$refs['execute_' + this.andExecute][0].click();
      this.andExecute = false;
    }
  },
  computed: {
    ...mapGetters([
      'FIELDS_LIST',
      'GOODS_LIST',
      'CURRENT_PAGE',
      'AMOUNT_PAGE',
      'COUNT_ROW',
      'EXPORT_LIST',
      'PAGE_SIZE',
    ]),

    getColumnList: function () {
      var th = this;
      var columnList = [];
      this.getFieldsList.forEach((val, index) => {
        columnList.push(index + 1);
      });

      return columnList.filter(function (val) {
        for (let key in th.affiliateField) {
          if (th.affiliateField[key] == val) {
            return false;
          }
        }
        return true;
      });
    },
    getAuthToken: function () {
      return localStorage.authToken
    },
    getFieldsList: function () {
      var fields = [];
      this.FIELDS_LIST.forEach((val) => {
        fields.push({
          key: val.key,
          label: val.label,
          sortable: true
        });
      });
      return fields;
    }
  },
  mounted: function () {

    // check permission
    if (this.$store.getters.getAllowSection.indexOf('product') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
    this.initPageSize();
    this.EXPORT_LIST_UPDATE({th: this});
    this.GET_ALL({th: this});
    this.widthTab();
  },
  created() {
    window.addEventListener("resize", this.widthTab);
  }
}
</script>

<style scoped>
.tab-width {
  width: 20000px;
}

.tab-scroll {
  overflow-x: scroll;
  width: 1920px;
}

.t-cell {
  overflow: hidden;
  display: block;
  height: 23px;
  font-size: 0.9rem;
  padding: 0 0.2rem;
}

.resizable-component {
  overflow-y: hidden;
  overflow-x: hidden;
  background-color: #e9ecef;
  padding: 0.5rem;
  text-align: left;
  font-size: 0.9rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin: 0;
}

.cell-detail.resizable-content {
  background-color: #e9ecef;
}

.cell-cursor {
  cursor: cell;
  padding: 1px;
}

.cell-cursor:hover {
  border: solid 1px grey;
  padding: 0;
}

.cell-cursor.selectedCall {
  border: solid 2px #007bff;
  padding: 0;
}

.name-coll-selected {
  font-size: 0.8rem;
  display: block;
}

.common-head-cell {
  height: 4rem;
  display: block;
  text-align: center;
  padding: 0 0.2rem;
}

.index-call {
  vertical-align: middle;
}

.t-head-cell.number-head {
  display: block;
}

.text-align-left {
  text-align: left;
}

.text-align-right {
  text-align: right;
}

.resizable-content {
  height: 100%;
  width: 100%;
  background-color: aqua;
}

.b-table-sticky-header, .table-responsive, [class*="table-responsive-"] {
  margin-bottom: 0;
}

.apply-cancel-import {
  width: 150px;
}

.pagination-box {
  overflow: auto;
}

.export-list {
  text-align: left;
  overflow-y: scroll;
}

.toggle .waiting-state {
  display: none;
}

.toggle .process-state {
  display: inline;
}

.process-state {
  display: none;
}

.execute-link {
  display: inline-block;
  width: 90%;
  text-align: center;
}

.execute-link-box {
  border: solid 1px #dee2e6;
  border-radius: 7px;
  padding: 3px;
  float: left;
  width: 90%;
}
</style>

<style>
.table th, .table td {
  padding: 0;
  vertical-align: middle;
}

.goods-import html {
  overflow-x: hidden;
}

.form-line-container label {
  margin-right: 10px;
}

.table .thead-dark th {
  position: relative;
  padding: 5px;
}
</style>